import './virtualTour.css';

export const virtualTour = {
  url: '',
  currentUrl: '',
  popinSelector: '.virtualTourPopin',
  showPopinSelector: '.js-showVirtualTour',
  closePopinSelector: '.js-closePopinBottom',

  init() {
    this.initEvents();
  },

  initEvents() {
    $(document).off('click', this.showPopinSelector).on('click', this.showPopinSelector, (e) => {
      this.url = $(e.currentTarget).data('url');
      this.show(e);
    });

    $(document).off('click', this.closePopinSelector).on('click', this.closePopinSelector, (e) => {
      this.hide();
    });
  },

  render() {
    const popinHtml = this.templatePopin();

    if ($(this.popinSelector).length) {
      $(this.popinSelector).replaceWith(popinHtml);
    } else {
      $('body').append(popinHtml);
    }
  },

  show(event) {
    if (this.url !== this.currentUrl) {
      this.render();
      this.currentUrl = this.url;
    }

    setTimeout(() => {
      $(this.popinSelector).removeClass('closed');
      genericScrollTo.canIScroll(DEVICE.isMobile);
    }, 0);

    // -- Tracking open virtual tour
    let gaActionValue = '';
    const originLink = $(event.currentTarget).data('origin') || '';

    if (originLink === 'cottageDetail') {
      gaActionValue = 'Accommodation pop in';
    } else {
      const gaActionsList = {
        [`tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`]: 'Item list',
        [`tab_${GLOBAL_SCRIPTS.UNIVERS}_activities`]: 'Pop in activities',
        [`tab_${GLOBAL_SCRIPTS.UNIVERS}_catering`]: 'Pop in service'
      };
      gaActionValue = typeof PRODUCT_SCRIPTS !== 'undefined' ? gaActionsList[PRODUCT_SCRIPTS.PRODUCT_TAB] : 'Item list';
    }

    Tracking.dataLayerPush({
      event: 'clickEvent',
      gaCategory: 'Virtual medias',
      gaAction: gaActionValue,
      gaLabel: 'Click on the CTA 360 virtual tour'
    });
  },

  hide() {
    $(this.popinSelector).addClass('closed');
    genericScrollTo.canIScroll(DEVICE.isMobile);
  },

  templatePopin() {
    return `
    <div class="popinBottom virtualTourPopin closed">
      <i class="js-closePopinBottom icon icon-close"></i>
      <div class="c_loader">
        <div class="c_loader-bounce1"></div>
        <div class="c_loader-bounce2"></div>
        <div class="c_loader-bounce3"></div>
      </div>
      <iframe src="${this.url}"></iframe>
    </div>`;
  }
};